import { useQuery } from '@tanstack/react-query'

import { GetFluxoPagamentosService } from '@/http/get-fluxo-pagamentos-simulacao.service'

export const useFluxoPagamento = (ids: string[], queryKey: readonly unknown[]) => {
  return useQuery({
    queryFn: async () => {
      const response = await new GetFluxoPagamentosService().execute(ids)
      return response.data
    },
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey,
    staleTime: 1000 * 60 * 30,
  })
}
